setTimeout(function(){
function changeCUR(el, text){
    if(text.indexOf("€") >= 0 ) {  
        var indx = text.indexOf('.');
        if(indx > -1){
          text = text.replace(',','.');
          var price = text.substring(0,indx) + ',' + text.substring(indx+1);          
        }else{
          price = text.replace(',','.');        
        }
        el.textContent = price;
      }
  }
  
  var eur = document.querySelectorAll("#f-prices-currency").forEach(el => {
    changeCUR(el, el.textContent.trim());
  })
}, 2500);

if(document.querySelector('select[name="country_code"]').value != "GB"){
document.querySelector('#search-button').addEventListener('click', function(e){ 
  e.preventDefault();
  var shop__url = window.location.origin ;
  document.querySelector('#search-form').action = `${shop__url}/${window.Shopify.locale}-${ (window.Shopify.country).toLowerCase()}/search`;
  document.querySelector('#search-form').submit();
});

document.querySelectorAll('a[data-ps-item]').forEach( a => {
  var shop__url = window.location.origin ;
  var href = a.href;
  var sIndex = href.indexOf('/search?');
  var enIndex = shop__url.indexOf('en-');
  if(sIndex > -1 ){
    a.href = `${shop__url}/${window.Shopify.locale}-${(window.Shopify.country).toLowerCase()}/${href.substring(sIndex+1)}`;   
  }
  
});
}